const Calendar = {
  sunday: 'อา',
  monday: 'จ',
  tuesday: 'อ',
  wednesday: 'พ',
  thursday: 'พฤ',
  friday: 'ศ',
  saturday: 'ส',
  ok: 'ตกลง',
  today: 'วันนี้',
  yesterday: 'เมื่อวาน',
  hours: 'ชม.',
  minutes: 'นาที',
  seconds: 'วินาที',
  /**
   * Format of the string is based on Unicode Technical Standard #35:
   * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
   **/
  formattedMonthPattern: 'MMM YYYY',
  formattedDayPattern: 'DD MMM YYYY',
};

export const th = {
  Pagination: {
    more: 'More',
    prev: 'Previous',
    next: 'Next',
    first: 'First',
    last: 'Last',
  },
  Table: {
    emptyMessage: 'No data found',
    loading: 'Loading...',
  },
  TablePagination: {
    lengthMenuInfo: '{0} / page',
    totalInfo: 'Total: {0}',
  },
  Calendar,
  DatePicker: {
    ...Calendar,
  },
  DateRangePicker: {
    ...Calendar,
    last7Days: 'สัปดาห์ก่อน',
  },
  Picker: {
    noResultsText: 'No results found',
    placeholder: 'Select',
    searchPlaceholder: 'Search',
    checkAll: 'All',
  },
  InputPicker: {
    newItem: 'New item',
    createOption: 'Create option "{0}"',
  },
  Uploader: {
    inited: 'Initial',
    progress: 'Uploading',
    error: 'Error',
    complete: 'Finished',
    emptyFile: 'Empty',
    upload: 'Upload',
  },
};

export default th;
